export default "__VITE_ASSET__8gL9HhCq__"